import React, { useContext, useEffect } from 'react';

import { SingOutAccount } from '../../molecules';
import { DefaultLayout } from '../../layouts';

import { default as t } from '../../../utils/i18n';
import { UserContext } from '../../../context';
import { Loader } from '../../atoms';



const SignOut = props => {
  const { user,setUser } = useContext(UserContext);

  useEffect(() => {
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    setUser && setUser(null);
    console.log('useEffect SignOut', user);
    setTimeout(() => {
      window.location.href =  `${process.env.REACT_APP_UPA_BASE_URL}/signout`
    }, 100);
    
  }, []);

  return <Loader />

  return (
    <DefaultLayout>
      <SingOutAccount
        heading={t('signout.heading')}
        subheading={t('signout.subheading')}
        messageBody={t('signout.body')}
        buttonText={t('signout.buttonText.signInAgain')}
        navigationURL="/signout"
      />
    </DefaultLayout>
  );
};

export default SignOut;
